import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable";
import { Skeleton } from "@/components/ui/skeleton";

function ChatPanelSkeleton() {
	return (
		<div className="max-w-4xl mx-auto p-6 relative size-full">
			<div className="flex flex-col h-full">
				{/* Messages area */}
				<div className="flex-1 space-y-6 overflow-hidden">
					{/* User message skeleton */}
					<div className="flex justify-end">
						<Skeleton className="h-12 w-3/4 rounded-2xl" />
					</div>

					{/* Assistant message skeleton */}
					<div className="space-y-3">
						<div className="flex items-center gap-2">
							<Skeleton className="size-6 rounded-full" />
							<Skeleton className="h-4 w-20" />
						</div>
						<div className="space-y-2 pl-8">
							<Skeleton className="h-4 w-full" />
							<Skeleton className="h-4 w-5/6" />
							<Skeleton className="h-4 w-4/6" />
						</div>
					</div>

					{/* Another user message */}
					<div className="flex justify-end">
						<Skeleton className="h-10 w-2/3 rounded-2xl" />
					</div>

					{/* Another assistant response */}
					<div className="space-y-3">
						<div className="flex items-center gap-2">
							<Skeleton className="size-6 rounded-full" />
							<Skeleton className="h-4 w-20" />
						</div>
						<div className="space-y-2 pl-8">
							<Skeleton className="h-4 w-full" />
							<Skeleton className="h-4 w-11/12" />
							<Skeleton className="h-4 w-3/4" />
							<Skeleton className="h-4 w-1/2" />
						</div>
					</div>
				</div>

				{/* Input area skeleton */}
				<div className="mt-4 space-y-3">
					<Skeleton className="h-24 w-full rounded-xl" />
					<div className="flex items-center justify-between">
						<div className="flex items-center gap-2">
							<Skeleton className="size-8 rounded-lg" />
							<Skeleton className="size-8 rounded-lg" />
							<Skeleton className="h-8 w-24 rounded-lg" />
						</div>
						<Skeleton className="size-10 rounded-full" />
					</div>
				</div>
			</div>
		</div>
	);
}

function UIPreviewSkeleton() {
	return (
		<div className="p-6 space-y-6">
			{/* Preview header */}
			<div className="flex items-center justify-between">
				<Skeleton className="h-6 w-32" />
				<div className="flex items-center gap-2">
					<Skeleton className="size-8 rounded-lg" />
					<Skeleton className="size-8 rounded-lg" />
				</div>
			</div>

			{/* Preview content - code/UI blocks */}
			<div className="space-y-4">
				{/* Code block skeleton */}
				<div className="rounded-xl border border-border/50 overflow-hidden">
					<div className="bg-muted/30 px-4 py-2 flex items-center justify-between">
						<Skeleton className="h-4 w-24" />
						<Skeleton className="h-6 w-16 rounded" />
					</div>
					<div className="p-4 space-y-2 bg-muted/10">
						<Skeleton className="h-3 w-3/4" />
						<Skeleton className="h-3 w-1/2" />
						<Skeleton className="h-3 w-5/6" />
						<Skeleton className="h-3 w-2/3" />
						<Skeleton className="h-3 w-4/5" />
					</div>
				</div>

				{/* UI component preview skeleton */}
				<div className="rounded-xl border border-border/50 p-6 space-y-4">
					<Skeleton className="h-10 w-full rounded-lg" />
					<div className="flex gap-3">
						<Skeleton className="h-10 flex-1 rounded-lg" />
						<Skeleton className="h-10 w-24 rounded-lg" />
					</div>
					<div className="grid grid-cols-2 gap-3">
						<Skeleton className="h-20 rounded-lg" />
						<Skeleton className="h-20 rounded-lg" />
					</div>
				</div>
			</div>
		</div>
	);
}

export function ThreadSkeleton() {
	return (
		<div className="h-screen w-full">
			<ResizablePanelGroup direction="horizontal" id="chat-layout">
				<ResizablePanel defaultSize="40%" minSize="20%" maxSize="60%">
					<ChatPanelSkeleton />
				</ResizablePanel>
				<ResizableHandle />
				<ResizablePanel defaultSize="60%">
					<UIPreviewSkeleton />
				</ResizablePanel>
			</ResizablePanelGroup>
		</div>
	);
}
